import type { AvailabilityInfo } from "~/api/pna/AvailabilityInfo";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import type { PackagingInformationEntry, WarehouseStockData } from "~/models/ProductData";
import { toMapFn } from "~/utils/reducers";

export function constructAvailability(product: ProductDescriptor): ProductDescriptor {
  const salesByCode = product.base.salesCampaign;
  const fifteenDigitByCode = product.base.fifteenDigit;

  if (
    !fifteenDigitByCode ||
    Object.keys(fifteenDigitByCode).length === 0 ||
    !salesByCode ||
    Object.keys(salesByCode).length === 0
  ) {
    return product;
  }

  const packagingInformation: PackagingInformationEntry[] = Object.keys(fifteenDigitByCode).map((packCode) => {
    const salesData = salesByCode[packCode] ?? [];
    const fifteenDigitEntry = fifteenDigitByCode[packCode];
    return {
      minOrderQuantity: 1,
      totalWarehouse: EMPTY_WAREHOUSE,
      global: EMPTY_WAREHOUSE,
      warehouses: [],
      packCode,
      packSize: fifteenDigitEntry.packSize,
      preferredPackQuantity: null,
      primaryWarehouseCode: "",
      primaryWarehouseName: "",
      replenishmentLeadTimeDate: null,
      salesStock: toMapFn(
        salesData,
        (sale) => sale.code,
        (sale) => sale.quantity,
      ),
    };
  });
  const availability: AvailabilityInfo = {
    code: product.base.code,
    hasPackaging: true,
    isFreshPnaCall: false,
    sapMaterialNumber: product.base.sapMaterialNumber,
    packagingInformation,
  };

  return {
    ...product,
    availability,
    isLoaded: product.prices.length > 0,
    isLoading: product.isPriceLoading,
  };
}

const EMPTY_WAREHOUSE: WarehouseStockData = {
  code: "",
  name: "",
  inClarification: 0,
  inProduction: [],
  inStock: [],
  inStockWeekly: [],
  inProductionWeekly: [],
};
